import React, { useEffect, useState } from 'react';

const MyCustomRain = () => {
  // Number of capsules created
  const nbCapsule = 858;

  // Function to generate a random number range
  const randRange = (minNum, maxNum) => {
    return Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum;
  };

  // State to hold the capsules
  const [capsules, setCapsules] = useState([]);

  // Function to create capsules
  const createCapsules = () => {
    const newCapsules = [];
    for (let i = 1; i <= nbCapsule; i++) {
      const capsuleLeft = randRange(0, window.innerWidth - 30); // Adjust for image width
      const delay = i * 100; // Increase delay for each capsule to stagger the fall
      const speed = randRange(6, 10); // Random speed between 3s and 10s
      const angle = randRange(-15, 15); // Random angle for the capsule's fall
      const size = randRange(20, 60); // Random size between 40px and 60px
      const isReverse = Math.random() < 0.5; // 50% chance to reverse direction

      newCapsules.push(
        <img
          key={i}
          src="/assets/images/capsule-1.svg" // Path to your capsule image
          alt="Capsule"
          className="capsule"
          style={{ 
            left: capsuleLeft, 
            animationDelay: `${delay}ms`, 
            animationDuration: `${speed}s`, // Set the random speed
            transform: `rotate(${angle}deg)`, // Set a random rotation angle
            width: `${size}px`, // Set the random width
            height: `${size}px`, // Set the random height
            transform: isReverse ? `rotate(${angle + 180}deg)` : `rotate(${angle}deg)` // Reverse direction if needed
          }} 
        />
      );
    }
    setCapsules(newCapsules);
  };

  // Create capsules when the component mounts
  useEffect(() => {
    createCapsules();
  }, []);

  return (
    <div className="MyCustomRain" style={{ position: 'relative', overflow: 'hidden', height: '100vh', background: 'white' }}>
      <section className="rain">{capsules}</section>
      {/* <div className='splash-logo'>
        <img src="/assets/images/banner-log.svg" alt="" />
      </div> */}
    </div>
  );
};

export default MyCustomRain;
